import React from "react";
import styled, { keyframes } from "styled-components";
import { colorTextAdditional } from "../../../utils/palette";
import { getCategoryColour } from "../utils/categoryColours";

const Card = styled.div`
  background: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 12px;
  padding: 14px 16px;
  position: relative;
  overflow: hidden;
  cursor: default;
  transition: box-shadow 0.15s;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
`;

const CategoryDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $colour }) => $colour};
  flex-shrink: 0;
`;

const CategoryLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${colorTextAdditional};
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const ValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
`;

const Value = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: #1b2a4a;
  line-height: 1;
`;

const Descriptor = styled.p`
  font-size: 11px;
  color: ${colorTextAdditional};
  margin: 0;
`;

// ── Skeleton shimmer ────────────────────────────────────────────────────────

const shimmer = keyframes`
  0%   { background-position: 200% center; }
  100% { background-position: -200% center; }
`;

const Skeleton = styled.div`
  height: ${({ $h }) => $h || "14px"};
  width: ${({ $w }) => $w || "100%"};
  border-radius: 4px;
  background: linear-gradient(90deg, #e7eaf0 25%, #f5f6f8 50%, #e7eaf0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease infinite;
  margin-bottom: ${({ $mb }) => $mb || "0"};
`;

export default function KPICard({
  label,
  value,
  subLabel,
  loading,
  domain,
  categoryLabel,
}) {
  const colour = getCategoryColour(domain);

  return (
    <Card>
      <CategoryHeader>
        <CategoryDot $colour={colour} />
        {label && <CategoryLabel>{label}</CategoryLabel>}
      </CategoryHeader>
      {loading ? (
        <>
          <Skeleton $h="26px" $w="60%" $mb="6px" />
          <Skeleton $h="11px" $w="80%" />
        </>
      ) : (
        <>
          <ValueRow>
            <Value>{value}</Value>
          </ValueRow>
          {/* <Descriptor>{label}</Descriptor> */}
          {subLabel && (
            <Descriptor style={{ marginTop: 2 }}>{subLabel}</Descriptor>
          )}
        </>
      )}
    </Card>
  );
}
